import { getCart, getTotalItemsInCart } from 'lib/util/cart';

import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useState,
  useMemo,
  useEffect,
} from 'react';

type CartContextType = {
  cartContext: number;
  setCartContext: Dispatch<SetStateAction<number>>;
};

const CartContext = createContext<CartContextType | undefined>(undefined);

export const CartContextProvider: React.FC = ({ children }) => {
  const [cartContext, setCartContext] = useState<number>(0);

  const contextValue = useMemo(() => {
    return { cartContext, setCartContext };
  }, [cartContext]);

  useEffect(() => {
    if (typeof window !== 'undefined' && window.localStorage) {
      const itemCount = getTotalItemsInCart(getCart());
      setCartContext(itemCount);
    }
  }, [setCartContext, cartContext]);

  return <CartContext.Provider value={contextValue}>{children}</CartContext.Provider>;
};

export const useCartContext = () => {
  const context = useContext(CartContext);

  if (context === undefined) {
    throw new Error('useCartContext must be used within a CartContextProvider');
  }
  return context;
};
